export enum RouteNameEnum {
    AI = 'ai',
    CREATE_DATA = 'create-data',
    CREATE_PROJECT = 'create-project',
    ENTITY_DETAIL = 'entity-detail',
    FIELD_INTERVENTIONS = 'field-interventions',
    FIELD_INTERVENTION_ENTITIES = 'entities',
    FORMS = 'forms',
    HOME = 'home',
    LAYERS = 'layers',
    LOGIN = 'login',
    MANAGEMENT_DATA = 'management-data',
    NOTIFICATION = 'notification',
    ORGANIZATION_DATA = 'organization-data',
    PASSWORD_RULES = 'password-rules',
    PROJECTS = 'projects',
    REFERENCE_DATA = 'reference-data',
    ROLES = 'roles',
    SETTINGS = 'settings',
    STATISTICS = 'statistics',
    SYNOPTIC = 'synoptic',
    USERS = 'users',
    USERS_ROLES = 'users-roles',
    USER_DEPOSIT = 'user-deposit',
}

export enum RoutePathEnum {
    AI = 'ai',
    CHANGE_PASSWORD = 'change-password',
    DEPOSIT_DETAIL = 'deposit',
    DEPOSIT_DETAIL_ID = 'depositDetailId',
    DEPOSIT_EDITION = 'deposit-edition',
    DEPOSIT_ID = 'depositId',
    DETAIL_LAYER_ID = 'detailLayerId',
    ENTITY = 'entity',
    ENTITY_DETAIL = 'entity-detail',
    ENTITY_ID = 'entityId',
    EXT = 'ext',
    FIELD_INTERVENTIONS = 'field-interventions',
    FIELD_INTERVENTION_CHANGE_SELECTION = 'change-selection',
    FIELD_INTERVENTION_CREATE = 'create',
    FIELD_INTERVENTION_DASHBOARD = 'dashboard',
    FIELD_INTERVENTION_ENTITIES = 'entities',
    FIELD_INTERVENTION_ENTITY_ID = 'fieldInterventionEntityId',
    FIELD_INTERVENTION_FORMS = 'field-intervention-forms',
    FIELD_INTERVENTION_FORM_ID = 'fieldInterventionFormId',
    FIELD_INTERVENTION_ID = 'fieldInterventionId',
    FIELD_INTERVENTION_LAYERS = 'layers-table',
    FIELD_INTERVENTION_LAYER_ID = 'fieldInterventionLayerId',
    FIELD_INTERVENTION_PLANNING = 'planning',
    FINALIZE_INVITATION = 'finalize-invitation',
    FORGOT_PASSWORD = 'forgot-password',
    FORMS = 'forms',
    FORM_ID = 'formId',
    HOME = 'home',
    LAYERS = 'layers',
    LAYER_FILTER = 'layer-filter',
    LAYER_FILTER_ID = 'layerFilterId',
    LAYER_ID = 'layerId',
    LOGIN = 'login',
    MANAGEMENT_DATA = 'management-data',
    MANAGEMENT_NO_PERMISSION = 'management-no-permission',
    MANAGEMENT_ORGANIZATION = 'management-organization',
    NETWORK_PATH = 'network-path',
    NOTIFICATION = 'notification',
    ONE_GEO_SUITE = 'ogs',
    ORGANIZATION_DATA = 'organization-data',
    PASSWORD_RULES = 'password-rules',
    PROFILE = 'profile',
    PROJECTS = 'projects',
    PROJECT_ID = 'projectId',
    REFERENCE_DATA = 'reference-data',
    ROLE = 'role',
    ROLES = 'roles',
    ROLE_EDITION = 'role-edition',
    ROLE_ID = 'roleId',
    SECURITY = 'security',
    SETTINGS = 'settings',
    SSO = 'sso',
    STATISTICS = 'statistics',
    STATISTICS_EXPORT = 'statistics-export',
    SYNOPTIC = 'synoptic',
    SYNOPTIC_PLAN = 'plan',
    TABLE_ENTITY_DETAIL = 'table-entity-detail',
    TABLE_ENTITY_ID = 'tableEntityId',
    USER = 'user',
    USERS = 'users',
    USERS_ROLES = 'users-roles',
    USER_EDITION = 'user-edition',
    USER_ID = 'userId',
}

export const RouteCompletePathEnum = {
    ORGANIZATION_DATA: [RoutePathEnum.MANAGEMENT_DATA, RoutePathEnum.ORGANIZATION_DATA],
    PASSWORD_RULES: [RoutePathEnum.MANAGEMENT_ORGANIZATION, RoutePathEnum.PASSWORD_RULES],
    REFERENCE_DATA: [RoutePathEnum.MANAGEMENT_DATA, RoutePathEnum.REFERENCE_DATA],
    USERS_ROLES: [RoutePathEnum.MANAGEMENT_ORGANIZATION, RoutePathEnum.USERS_ROLES],
};
